<template>
  <div class="page">
    <navigation class="header">申请展期确认</navigation>
    <common :index="0" />
    <section class="section flex-shrink0">
      <div class="card">
        <div class="platform" v-if="loanPlatform !== 'TMD'">
          <img class="icon" :src="platform.icon" />
          <span class="name">{{ platform.name }}</span>
        </div>
        <div class="card-amount">
          <div class="amount-container">
            <span>{{ repaymentTrail.prin | currency }}</span>
            <img v-if="repaymentTrail.shouldAmt || repaymentTrail.wavAmt || repaymentTrail.paidAmt" @click="showDetail" src="../images/icon_info.png" srcset="../images/icon_info@2x.png 2x,../images/icon_info@3x.png 3x"/>
          </div>
          <div class="del" v-if="repaymentTrail.shouldAmt !== repaymentTrail.prin">展期后应还总额：<span class="line-throuth">{{ repaymentTrail.shouldAmt | currency }}</span> </div>
        </div>
        <div class="repay-list">
          <div class="repay-list-item">
            <p class="thin">应还本金（元）</p>
            <p>{{ repaymentTrail.shouldAmt | currency }}</p>
          </div>

          <div class="repay-list-item">
            <p class="thin">利息（元）</p>
            <p>{{ repaymentTrail.interest | currency }}</p>
          </div>

          <div class="repay-list-item" v-if="repaymentTrail.fee">
            <p class="thin">服务费（元）</p>
            <p>{{ repaymentTrail.fee | currency }}</p>
          </div>

          <div class="repay-list-item" v-if="repaymentTrail.pen">
            <p class="thin">罚息（元）</p>
            <p>{{ repaymentTrail.pen | currency }}</p>
          </div>

          <!-- <div class="repay-list-item" v-if="repaymentTrail.paidAmt">
            <p class="thin">线下转账（元）</p>
            <p>{{ repaymentTrail.paidAmt | currency }}</p>
          </div>

          <div class="repay-list-item" v-if="repaymentTrail.wavAmt">
            <p class="thin">减免金额（元）</p>
            <p>{{ repaymentTrail.wavAmt | currency }}</p>
          </div> -->
        </div>
      </div>

      <div class="repayment-type">
        <nd-choose name="type" v-model="form.type" :data="typeOptions" :valueKey="['key', 'description']" label="还款方式" :editable="true">
          <label class="label"><img src="../images/icon_fangshi.png" srcset="
                                ../images/icon_fangshi@2x.png 2x,
                                ../images/icon_fangshi@3x.png 3x
                            "
          />还款方式</label>
        </nd-choose>
      </div>
    </section>

    <div class="footer flex-shrink0">
      <nd-button class="btn" @click="confirmRepay">下一步：展期订单申请</nd-button>
    </div>

    <nd-dialog v-model="detailDialogVisible" @close="closeDialog" :footer="false" :close-btn="true">
      <div class="detail-dialog">
        <div class="title">展期后实还金额</div>
        <div class="amount">
          ¥ {{ repaymentTrail.prin | currency }}
        </div>
        <div class="item">
          <div v-if="repaymentTrail.shouldAmt">
            <label class="des">本金（元）</label><span>{{ repaymentTrail.shouldAmt | currency }}</span>
          </div>
          <div v-if="repaymentTrail.interest">
            <label class="des">利息（元）</label><span>-{{ repaymentTrail.interest | currency }}</span>
          </div>
          <div v-if="repaymentTrail.fee">
            <label class="des">服务费（元）</label><span>-{{ repaymentTrail.fee | currency }}</span>
          </div>
          <div v-if="repaymentTrail.pen">
            <label class="des">罚息（元）</label><span>-{{ repaymentTrail.pen | currency }}</span>
          </div>
          <div v-if="repaymentTrail.wavAmt">
            <label class="des">减免金额（元）</label><span>-{{ repaymentTrail.wavAmt | currency }}</span>
          </div>
        </div>
      </div>
    </nd-dialog>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { getKey, setKey } from '../../../assets/utils'
import common from './components/common.vue'
export default {
  name: 'consult-confirm',
  components: {
    common
  },
  data () {
    return {
      loanPlatform: this.$route.query.loanPlatform || 'TMD',
      orderId: this.$route.query.orderId || '',
      detailDialogVisible: false,
      termId: this.$route.query.termId, // 还款期数 查询银行卡需要
      repaymentTrail: {},
      form: {
        type: 'XIESHANG'
      },
      allPlatForm: [],
      selectedBankcard: {} // 选择的银行卡
    }
  },

  async created () {
    try {
      await this.getRepayTrial()
      if (this.loanPlatform !== 'TMD') {
        this.getPlatform()
      }
      this.$bus.$emit('ready')
    } catch (error) {
      this.$bus.$emit('error')
    }
  },

  computed: {
    typeOptions () {
      return [{ key: 'XIESHANG', description: '展期' }]
    },

    platform () {
      const platform = getKey('platform') || this.allPlatForm
      const result = platform && platform.find(item => item.loanPlatform === this.loanPlatform)
      if (result) {
        return {
          name: result.loanPlatformName,
          icon: result.iconUrl
        }
      }
      return {
        name: platform && platform['TMD'] && platform['TMD'].loanPlatformName,
        icon: platform && platform['TMD'] && platform['TMD'].iconUrl
      }
    }
  },

  watch: {
    detailDialogVisible (value) {
      this.$report({
        id: 10104,
        args: {
          position: this.loanPlatform,
          visible: value ? 1 : 0
        }
      })
    }
  },

  methods: {
    ...mapActions('repay', ['repayApplyX', 'getRepayTrialX', 'consult']),
    ...mapActions('order', ['getPlatformX']),
    // 获取试算数据
    async getRepayTrial () {
      let trafficCode = getKey('channel') ? { trafficCode: getKey('channel') } : {}
      const { success, data } = await this.consult({
        originalPlatBillNo: this.orderId,
        loanPlatform: this.loanPlatform,
        productCode: 'TMDE',
        ...trafficCode
      })
      if (success) {
        this.repaymentTrail = data || {}
      }
    },
    closeDialog () {
      this.$report({
        id: 10062,
        args: {
          postion: 'page_repayment_consult'
        }
      })
    },
    showDetail () {
      this.detailDialogVisible = true
    },
    async confirmRepay () {
      this.$router.push({ path: '/repayment/consult/apply', query: { orderId: this.orderId, loanPlatform: this.loanPlatform } })
    },
    // 获取平台枚举
    async getPlatform () {
      const res = await this.getPlatformX()
      if (res.code === '000000') {
        setKey('platform', res.data)
        this.allPlatForm = res.data
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.label {
  display: flex;
  align-items: center;
  font-size: 30px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);

  >img {
    width: 44px;
    height: 44px;
    margin-right: 16px;
  }
}

.page {
  height: 100%;
  background-color: #fafafa;
  display: flex;
  flex-direction: column;

  .section {
    flex: 1;
    padding: 30px;

    .card {
      border-radius: 20px;
      padding: 42px 0 0 0;
      background-color: #ffffff;
      box-sizing: border-box;

      .platform {
        padding: 0 30px;
        height: 36px;
        line-height: 36px;
        display: flex;
        flex-direction: row;
        align-items: center;

        .icon {
          width: 36px;
          height: 36px;
        }

        .name {
          font-size: 26px;
          padding-left: 8px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
        }
      }

      .card-amount {
        display: flex;
        flex-direction: column;
        align-items: center;
        .amount-container{
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 65px;
          font-size: 72px;
          font-family: DIN-Medium, DIN;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 67px;
          text-align: center;
          text-indent: 20px;
          >img {
            width: 23px;
            height: 23px;
            margin-left: 10px;
          }
        }
        .del {
          font-size: 24px;
          color: #999999;
          padding-top: 10px;
        }
        .line-throuth {
          text-decoration: line-through;
        }
      }

      .origin-amount {
        font-size: 24px;
        height: 33px;
        line-height: 33px;
        margin-top: 13px;
        text-align: center;
        text-decoration: line-through;
        color: @fc3;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
      }

      .repay-list {
        margin-top: 74px;
        display: grid;
        grid-template-columns: 50% 50%;
        // grid-row-gap: 7px;
        font-size: 24px;
        text-align: left;
        color: #333333;
        line-height: 33px;

        .repay-list-item {
          border-top: 1px solid #EEEEEE;
          border-bottom: 1px solid #EEEEEE;
          height: 99px;
          padding: 14px 30px 11px;

          &:nth-child(2n) {
            border-left: 1px solid #EEEEEE;
          }

          .thin {
            height: 33px;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 33px;
            margin-bottom: 4px;
          }
        }
      }
    }

    .repayment-type {
      margin-top: 30px;
      background-color: #ffffff;
      padding: 35px;
      border-radius: 20px;

      .label img {
        width: 44px;
        height: 44px;
      }
    }
  }

  .footer {
    height: 180px;
    background-color: #ffffff;

    .btn {
      margin: 28px auto 0;
    }
  }

  .detail-dialog {
    margin: 0px 0px 57px 45px;

    .title {
      font-size: 42px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      line-height: 72px;
    }

    .amount {
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 32px;
      margin-top: 12px;
    }

    .item {
      margin-top: 32px;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 40px;

      .des {
        display: inline-block;
        padding-right: 10px;
      }
    }
  }
}
</style>
